import React from 'react';
import { Link } from 'react-router-dom';

import GalleryItem from './GalleryItem';
import './styles.css'
import cUtilFecha from 'helpers/cUtilFecha';

const Gallery = (props) => {
  // mapping over the items of the data passed as props to the Gallery component
  const { data,pathURL } = props;
  /*let images = props.data.map(images =>
     <GalleryItem
       url={`${ props.pathURL}${images.filename}`}
       key={images.id_image}
     />
   );*/
  //let {fecha_reg, detalle, filename } = props;
  let formato_fecha=(fechamy)=>{
    //console.log("fechamy:" + fechamy);
    let fecha = cUtilFecha.strToDate(fechamy);
    if(fecha===undefined) return;
    //console.log(fecha);
    return fecha.toLocaleDateString();
    
  } 
  const onClickItem =(e, item)=>{
    e.preventDefault()
    // call 
    props.onClick(item.filename)
  }
  const onClickBtn1 =(e, item)=>{
    e.preventDefault()
    // call 
    props.onClickBtn1(item)
  }
  /*detalle: ""
fecha_reg: "2025-10-09 00:00:00"
filename: "7hCD1676495251.jpg"
id_image: 20
id_paciente: 1*/
   return (
     <div className="file_manager">
       {/* ternary operator that checks if the data object passed as props have items in it */}
       <h2>{ ( data.length === 0 && props.match) ? 'Sorry no match found!' : <>.</>
          }</h2>
        <div className='row clearfix'>
          
          { data.map((item,index) =>(
            <div key={index} className="col-lg-4 col-md-4 col-sm-12">
              <div className='card'>
                <div className='file'>
                  
                  {/*<Link to={`/imagenzoom/${item.filename}`} >*/}
                  <a >
                    <div className="hover">
                        {/*-- boton para eliminar-- */}
                        <button type="button" className="btn btn-icon btn-icon-mini btn-round btn-danger"
                            onClick={ (e)=>onClickBtn1(e,item) }>
                            <i className="fa fa-trash"></i>
                        </button>
                    </div>
                    <div className="image" onClick={ (e)=>onClickItem(e,item) }>
                      <img  src={`${ pathURL }${item.filename}`}  alt="img" className="img-fluid" />
                    </div>
                    <div className="file-name">
                        <p className="m-b-5 text-muted" style={{ fontWeight: 700 }}>
                          {item.detalle}
                        </p>
                        <small>
                          <span className="date text-muted">{ formato_fecha(item.fecha_reg)  }</span>
                        </small>
                    </div>
                  </a>
                  {/*</Link>*/}
             
                </div>
              
              </div>
            </div>
            ))
          }
                 
       </div>
     </div>
   );

}

export default Gallery;